"use client"

import { getColor } from "@litonarefin/utils/color";
import { sanitize } from "@litonarefin/utils/miscellaneous";
import { getCleanSpacing } from "@litonarefin/utils/spacing";

const ListItem = ({ attributes }) => {
  const { style } = attributes;

  return (
    <>
      <li
        {...(attributes?.anchor && { id: attributes?.anchor })}
        className={`list-item${attributes?.jltClasses ? ` ${attributes.jltClasses}` : ""}`}
        dangerouslySetInnerHTML={{ __html: sanitize(attributes?.page_content || "") }}
      />
      <style jsx>{`
          .list-item {
            ${style?.color?.text || getColor(attributes?.textColor)
              ? `color: ${style?.color?.text || getColor(attributes?.textColor)};`
              : ""} ${style?.typography?.fontSize
              ? `font-size: ${style?.typography?.fontSize};`
              : ""}${style?.typography?.lineHeight
              ? `line-height: ${style?.typography?.lineHeight};`
              : ""}${style?.typography?.textTransform
              ? `text-transform: ${style?.typography?.textTransform};`
              : ""}${style?.typography?.letterSpacing
              ? `letter-spacing: ${style?.typography?.letterSpacing};`
              : ""}${getCleanSpacing(style?.spacing?.margin?.top)
              ? `margin-top: ${getCleanSpacing(style?.spacing?.margin?.top)};`
              : ""} ${getCleanSpacing(style?.spacing?.margin?.bottom)
              ? `margin-bottom: ${getCleanSpacing(style?.spacing?.margin?.bottom)};`
              : ""} ${getCleanSpacing(style?.spacing?.margin?.left)
              ? `margin-left: ${getCleanSpacing(style?.spacing?.margin?.left)};`
              : ""} ${getCleanSpacing(style?.spacing?.margin?.right)
              ? `margin-right: ${getCleanSpacing(style?.spacing?.margin?.right)};`
              : ""} ${getCleanSpacing(style?.spacing?.padding?.top)
              ? `padding-top: ${getCleanSpacing(style?.spacing?.padding?.top)};`
              : ""} ${getCleanSpacing(style?.spacing?.padding?.bottom)
              ? `padding-bottom: ${getCleanSpacing(style?.spacing?.padding?.bottom)};`
              : ""} ${getCleanSpacing(style?.spacing?.padding?.left)
              ? `padding-left: ${getCleanSpacing(style?.spacing?.padding?.left)};`
              : ""} ${getCleanSpacing(style?.spacing?.padding?.right)
              ? `padding-right: ${getCleanSpacing(style?.spacing?.padding?.right)};`
              : ""}
            > a {
              color: var(--primary);
            }
          }
        `}</style>
    </>
  );
};

export default ListItem;
